import React, { Component, Fragment, useEffect, useCallback, useState, useRef } from 'react';
import './style.css';
import { Link, useHistory, useLocation, Redirect } from "react-router-dom";
import { Layout, Menu, Breadcrumb, Table, Modal, Button, Space, Form, Input, Row, Col, Checkbox, Switch, Divider, Card, Radio, Spin, Collapse, Select, Typography, Popconfirm } from 'antd';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, MoreOutlined, SyncOutlined, EditOutlined, SettingOutlined, EyeOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import Container from '../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { useSelector, useDispatch } from 'react-redux';
import { viewEditDirectorateAsyn, getSeenStampForAdminAsyn, updateSeenStampForAdminAsyn, updatedirectorateAsyn, viewEditDirectorateSelector, clearState, responseState, editIDAsyn, updateIDOnlyAsyn, clearResponseState } from './ViewEditDirectorateSlice';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import FormBuilder from 'antd-form-builder';
import Can from '../../config/Can';
import { RiDeleteBinLine } from 'react-icons/ri';
import { AiOutlineSave } from 'react-icons/ai';
const { Option } = Select;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { Search, TextArea } = Input;
const { Paragraph } = Typography;

export default function ViewEditDirectorate() {
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  let history = useHistory();
  const [state, setState] = useState({})
  const [dBranch, setDIR] = useState(null)
  const location = useLocation();
  const [expand, setExpand] = React.useState(false);
  const [counter, setCounter] = React.useState(0);
  const [expandable, setExpandable] = React.useState(true);
  const { isFetching, isSuccess, isError, errorMessage, directorate, isResponseState, seenStampData } = useSelector(
    viewEditDirectorateSelector
  );

  const MOCK_INFO = {
    name: '',
    referenceNumber: [],
    //referenceNumber: 'hi',
    description: '',
  }

  const idName = localStorage.getItem('deptTypeName') ? localStorage.getItem('deptTypeName') : location.state.idName;

  const [form] = Form.useForm()
  const [viewMode, setViewMode] = useState(true)
  const [pending, setPending] = useState(false)
  const [personalInfo, setPersonalInfo] = useState(MOCK_INFO)

  useEffect(() => {
    dispatch(clearState());

    if (location.state.idName) {
      localStorage.setItem('deptTypeName', location.state.idName);
    }

    let departmentName = localStorage.getItem('deptTypeName');

    let bData = {
      code: "id",
      deptTypeName: idName,
      departmentName: "Chief of Air Staff"
    };

    dispatch(viewEditDirectorateAsyn(bData));
    // setTimeout(() => {
    //   setDirectorate(true);
    // }, 5000);
    dispatch(getSeenStampForAdminAsyn());
  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);

      toast.error(errorMessage.toUpperCase());

    }
    if (isSuccess) {
      dispatch(clearState());
      let br = { name: directorate.name, referenceNumber: directorate.referenceNumber, description: directorate.description ? directorate.description[0] : '' };
      setPersonalInfo(br);
      let brState = { name: directorate.name, referenceNumber: directorate.referenceNumber, description: directorate.description ? directorate.description[0] : '' };
      setDIR(brState);

      if (directorate.referenceNumber) {
        let dref = [];
        directorate.referenceNumber.forEach(val => {
          dref.push({ referenceNumber: val })
          //console.log(val)
        });
        form.setFieldsValue({
          arr_referenceNumber: dref,
          templateData: directorate && directorate.templateDetail && directorate.templateDetail.processName ? directorate.templateDetail.processName : 'None',
        });
      }
    }

    if (isResponseState) {
      setLoading(false);
      dispatch(clearResponseState());
      //setBrStorage(brName);
    }
  }, [isError, isSuccess, isResponseState, setLoading, setToast]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const typoExpand = (e, i) => {
    // console.log(e)
    setExpand(true);
    let count = !expand ? counter + 0 : counter + 1;
    setCounter(count);
    setExpandable(false);
    // state['expand_'+i]?!state['expand_'+i]
    let name = 'expand_' + i;
    setState(prev => ({
      ...prev,
      [name]: !state['expand_' + i]
    }));
  };

  const typoClose = (i) => {
    setExpand(false);
    let count = !expand ? counter + 0 : counter + 1;
    setCounter(count);
    setExpandable(true);
    let name = 'expand_' + i;
    setState(prev => ({
      ...prev,
      [name]: !state['expand_' + i]
    }));
  };

  const onFinishFailed = (errorInfo) => {

    // console.log('Failed:', errorInfo);
  };

  const handleFinish = useCallback(values => {
    //console.log('Submit: ', values)
    setPending(true)
    setTimeout(() => {
      let referenceNumber = values.arr_referenceNumber.map(function ({ referenceNumber }) {
        return referenceNumber;
      });
      let data = {
        departmentName: "Chief of Air Staff",
        code: "id",
        deptTypeName: idName,
        change: {
          name: values.name,
          referenceNumber: referenceNumber,
          description: values.description
        }
      }


      dispatch(updatedirectorateAsyn(data)).then((res) => {

        if (res.code == 200) {
          const state = { ...history.location.state };
          delete state.idName;
          history.replace({ ...history.location, state });
          localStorage.removeItem("deptTypeName");
          localStorage.setItem('deptTypeName', values.name);
          setPending(false)
          let br = { name: values.name, referenceNumber: referenceNumber, description: values.description ? values.description : '' };
          setPersonalInfo(br);
          //setPersonalInfo(values)
          form.resetFields()
          resetDIR(values.name);
          setViewMode(true)
          Modal.success({
            title: 'Success',
            content: res.message,
          })
        }
        else {
          setPending(false)
          Modal.error({
            title: 'Error',
            content: res.message,
          })
        }



      });

    }, 1500)
  });


  const resetDIR = (brn) => {
    let bData = {
      code: "id",
      deptTypeName: brn,
      departmentName: "Chief of Air Staff"
    };

    dispatch(viewEditDirectorateAsyn(bData)).then((res) => {
      dispatch(clearState());
      let br = { name: directorate.name, referenceNumber: directorate.referenceNumber, description: directorate.description ? directorate.description[0] : '' };
      setPersonalInfo(br);
      let brState = { name: directorate.name, referenceNumber: directorate.referenceNumber, description: directorate.description ? directorate.description[0] : '' };
      setDIR(brState);
      if (directorate.referenceNumber) {
        let dref = [];
        directorate.referenceNumber.forEach(val => {
          dref.push({ referenceNumber: val })
          //console.log(val)
        });
        form.setFieldsValue({
          arr_referenceNumber: dref
        });
      }

    });

  }

  const saveIDName = (v) => {
    // console.log(v)
    if (form) {
      form
        .validateFields()
        .then(() => {
          setLoading(true);
          let obj = {
            "departmentName": "Chief of Air Staff",
            "code": "id",
            "deptTypeName": idName,
            "change": {
              "name": v
            }
          }
          dispatch(updateIDOnlyAsyn(obj)).then((res) => {
            setLoading(false);
            localStorage.setItem('deptTypeName', v);
            history.push({
              pathname: '/view-independent-directorate',
              // search: '?query=abc',
              state: { idName: v }
            });
            //dispatch(responseBrState(v));
          });
        });

    }
  }

  const saveID = (v, i) => {
    let idName = form.getFieldValue('name');
    let ref = form.getFieldValue('referenceNumber');
    let refIndexVal = ref[i];
    if (form) {
      form
        .validateFields()
        .then(() => {
          // console.log(JSON.stringify(refIndexVal))
          if (refIndexVal && refIndexVal._id) {
            setLoading(true);
            let obj = {
              "_id": refIndexVal._id,
              "code": "id",
              "deptTypeName": idName,
              "change": {
                "description": refIndexVal.description ? refIndexVal.description : '',
                "ref": refIndexVal.ref ? refIndexVal.ref : ''
              }
            }
            dispatch(editIDAsyn(obj)).then((res) => {
              dispatch(responseState());
            });
            // console.log(refIndexVal)
          }
          else {
            setLoading(true);
            let obj = {
              "code": "id",
              "deptTypeName": idName,
              "change": {
                "description": refIndexVal.description ? refIndexVal.description : '',
                "ref": refIndexVal.ref ? refIndexVal.ref : ''
              }
            }
            dispatch(editIDAsyn(obj)).then((res) => {
              dispatch(responseState());
            });
            //console.log(refIndexVal)
          }

        })
        .catch((errors) => {
          // Errors in the fields
        });
    }

  }

  const delID = (value, name) => {
    let idName = form.getFieldValue('name');
    setLoading(true);
    let obj = {
      "code": "id",
      "deptTypeName": idName,
      '_id': value[name]._id, 'delete': true
    }
    dispatch(editIDAsyn(obj)).then((res) => {
      dispatch(responseState());
    });

  }


  const getMeta = () => {
    const meta = {
      //columns: 2,
      disabled: pending,
      initialValues: personalInfo,
      fields: [
        {
          key: 'name',
          widget: ({ value, onChange }) => {
            return (
              <>

                <Form.Item style={{ marginBottom: 0, marginTop: 0 }}>
                  <p className={'refno-heading'}>Independent Directorate</p>
                  <Row>
                    <Col flex="100%" className={'refHeadingTbl'}>Name</Col>
                  </Row>
                  <Form.Item
                    name={'name'}
                    //style={{width:'80%',paddingTop:20,paddingBottom:20}}
                    style={{ display: 'inline-block', width: '89%', paddingTop: 20 }}
                    rules={[{ required: true, message: 'Name is required' }]}
                    requiredMark={'optional'}
                  //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                  >
                    <Input className="formInput" placeholder="" />
                  </Form.Item>
                  <Form.Item
                    style={{ display: 'inline-block', width: '10%', paddingTop: 30 }}
                  >
                    <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 0 }} onClick={() => saveIDName(value)} type="link"><AiOutlineSave /></Button>
                  </Form.Item>

                </Form.Item>
              </>
              //   <Form.Item
              //   name={'name'}
              //   //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
              //   >
              //  <Input className="formInput" placeholder="" />
              //   </Form.Item>
            )
          },
          renderView: (v) => {
            return (
              <h1 className="branchh1">{capitalizeFirstLetter(v)}</h1>
            )
          },
        },
        {
          key: 'referenceNumber',
          //label: 'Reference No.',
          renderView: (v) => {
            return (
              <>
                <p className={'refno-heading'}>Reference No</p>
                <p
                  style={{
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: 18,
                    color: "#000000",
                    marginBottom: 0,
                    wordBreak: 'break-all'
                  }}
                >
                  {/* {v.join(',')}  */}
                  <Row style={{ paddingBottom: 15 }}>
                    <Col span={8} className={'refHeadingTbl'}>Reference No</Col>
                    <Col span={16} className={'refHeadingTbl'}>Description</Col>
                  </Row>
                  {v && v.length > 0
                    ? <>
                      {
                        v.map((val, i) => {
                          return (
                            <Row className={'paddingBtableTop'}>
                              <Col span={8}>{val.ref}</Col>
                              <Col span={16}>
                                <div key={counter + 1}>

                                  <Paragraph
                                    ellipsis={{
                                      rows: 2,
                                      expandable: state && state['expand_' + i] ? true : expandable,
                                      symbol: 'More',
                                      onExpand: (e) => typoExpand(e, i)
                                    }}
                                  >
                                    {val.description}
                                  </Paragraph>
                                </div>
                                {state['expand_' + i] && <a onClick={() => typoClose(i)}>Close</a>}
                                {/* {expand && <a onClick={() => typoClose(i)}>Close</a>} */}
                              </Col>
                            </Row>
                          )
                        })

                      }
                    </>
                    : <Row className={'paddingBtableTop'}>
                      <Col span={24}>No records found</Col>
                    </Row>
                  }

                </p>
                {/* <p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:10,wordBreak:'break-all'}}>Reference No</p>
              <p
              style={{
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: 18,
                color: "#000000",
                marginBottom: 0,
                wordBreak:'break-all'
              }}
            >{v.join(',')}</p> */}
              </>
            )
          },
          widget: ({ value, onChange }) => {
            return (
              <>
                <p className={'refno-heading'}>Reference No</p>
                <Row style={{ paddingBottom: 15 }}>
                  <Col flex="30%" className={'refHeadingTbl'}>Reference No*</Col>
                  <Col flex="60%" className={'refHeadingTbl'}>Description</Col>
                </Row>
                <Form.List name="referenceNumber" initialValue={[{ ref: '', description: '' }]} >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Form.Item style={{ marginBottom: 0 }}>

                          <Form.Item
                            {...restField}
                            name={[name, 'ref']}
                            style={{ display: 'inline-block', width: 'calc(30% - 8px)', marginRight: 5 }}
                            label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}></p>}
                            fieldKey={[fieldKey, 'ref']}
                            rules={[{ required: true, message: 'Reference No is required' }]}
                            requiredMark={'optional'}
                          >
                            <Input className="formInput" placeholder="" />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, 'description']}
                            fieldKey={[fieldKey, 'description']}
                            style={{ display: 'inline-block', width: 'calc(60% - 8px)', marginTop: -9 }}
                            label={key == 0 ? <Row style={{ width: '100%' }}><Col style={{ textAlign: 'right' }} span={24}><Button style={{ fontSize: 18, fontWeight: 500, marginRight: -15 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%', marginBottom: 15 }}></Row>}
                          >

                            <TextArea style={{ lineHeight: 1.2 }} rows={0} className="formInput" placeholder="" />
                          </Form.Item>
                          <Form.Item
                            style={{ display: 'inline-block', width: 'calc(10% - 8px)', marginTop: -9 }}
                          >
                            {key == 0
                              ? <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 45 }} onClick={() => saveID(value, name)} type="link"><AiOutlineSave /></Button>
                              : <>
                                <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 32 }} type="link">
                                  <Popconfirm onConfirm={() => { remove(name); if (value[name]) { delID(value, name) } }} title="Are you sure？" icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
                                    <a href="#"><RiDeleteBinLine /></a>
                                  </Popconfirm>
                                </Button>
                                <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 0 }} onClick={() => saveID(value, name)} type="link"><AiOutlineSave /></Button>
                              </>
                            }
                          </Form.Item>

                        </Form.Item>
                      ))}
                    </>
                  )}
                </Form.List>
              </>
              //   <Form.List name="arr_referenceNumber" initialValue={[{referenceNumber:''}]} >
              //   {(fields, { add, remove }) => (
              //     <>
              //       {fields.map(({ key, name, fieldKey, ...restField }) => (
              //         <Form.Item
              //         {...restField}
              //         name={[name,'referenceNumber']}

              //           label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
              //           fieldKey={[fieldKey, 'referenceNumber']}
              //           rules={[{ required: true, message: 'Reference No is required' }]}
              //           requiredMark={'optional'}
              //         >
              //           <Input className="formInput" placeholder="" />
              //         </Form.Item>
              //       ))}
              //     </>
              //   )}
              //  </Form.List>
            )
          },
          // render: () => {
          //   <h1>helo</h1>
          // }
        },
        // { 
        //   key: 'description', 
        //   //label: 'Description',
        //   widget: () => {
        //     return (
        //   <Form.Item
        //   name={'description'}
        //   label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
        //   >
        //   <TextArea rows={4} className="formInput" placeholder="" />
        //   </Form.Item>
        //     )},
        //   renderView: (v) => {
        //     return (
        //       <>
        //        <p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:10,wordBreak:'break-all'}}>Description</p>
        //       <p
        //       style={{
        //         fontStyle: "normal",
        //         fontWeight: "normal",
        //         fontSize: 18,
        //         color: "#000000",
        //         marginBottom: 0,
        //         wordBreak:'break-all'
        //       }}
        //     >{v}</p>
        //     </>
        //     )
        //   },
        //  },
      ],
    }
    return meta
  }


  const getItemSeenStampList = () => {
    let children = [];
    let seenStampList = seenStampData ? seenStampData : [];
    // console.log('seenStampList')
    // console.log(seenStampList)
    if (seenStampList && seenStampList.length > 0) {
      for (let i = 0; i < seenStampList.length; i++) {
        children.push(<Option key={i.toString() + i} value={seenStampList[i].uuid}>{seenStampList[i].processName}</Option>);
      }
    }
    return children;
  }


  const onTemplateListChange = (event, rowData, chnageData) => {

    // console.log("event =" + event + " rowData = " + JSON.stringify(rowData) + " chnageData =" + JSON.stringify(chnageData))

    let data = {
      "departmentName": "Chief of Air Staff",
      "code": "id",
      "deptTypeName": rowData.name,
      "deleteTemplateUUID": chnageData.value === 'None' ? true : false,
      // "templateUUID": chnageData.value,
    }
    if (chnageData.value != 'None') data["templateUUID"] = chnageData.value
    // console.log(data);
    dispatch(updateSeenStampForAdminAsyn(data));

  }



  return (
    <>
      <Container>
        <Breadcrumb style={{ margin: '16px 0', paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item><Link to={'/departments'}>Departments</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Independent Directorate</Breadcrumb.Item>
        </Breadcrumb>

        <div className="site-layout-content" style={{ marginTop: 0, paddingTop: 0 }}>

          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%', position: 'fixed', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }
            <div>
              <Row style={{ backgroundColor: "#ffffff", paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                <Col span="3"></Col>
                <Col span="12" >
                  <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Independent Directorate Details</h1>
                </Col>
                <Col span="9" style={{ paddingLeft: 25 }}>

                </Col>
              </Row>


              <Form
                form={form}
                layout="vertical"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 24 }}
                onFinish={handleFinish}
              >
                {/* <Row  style={{paddingTop:24,paddingBottom:80,borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',borderBottom:'1px solid #dfe0eb'}}> */}
                <Row style={{ backgroundColor: "#ffffff", paddingTop: 24, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb' }}>
                  <Col span="3"></Col>
                  <Col span="18"  >

                    <Form.Item name={'templateData'} className="independent-directorate-details-clps-from">

                      <Select
                        onChange={(event, chnagedata) => onTemplateListChange(event, personalInfo, chnagedata)}
                        onClick={event => { event.stopPropagation() }}
                        className='independent-directorate-details-clps-dropdown'>
                        <Option value="None">None</Option>
                        {getItemSeenStampList()}
                      </Select>

                    </Form.Item>

                    <Can I="manageId" a="edit">
                      {viewMode && (
                        <Button type="link" onClick={() => {
                          setViewMode(false)
                        }} style={{ fontWeight: 'normal', fontSize: 24, color: '#000', float: 'right' }}>
                          <EditOutlined /> &nbsp;Edit
                        </Button>
                      )}
                    </Can>

                    <FormBuilder form={form} getMeta={getMeta} viewMode={viewMode} />
                    {!viewMode && (
                      <Form.Item className="form-footer" wrapperCol={{ span: 24, offset: 0 }}>
                        {/* <Button htmlType="submit" type="primary" disabled={pending}>
              {pending ? 'Updating...' : 'Update'}
            </Button> */}
                        <Button
                          type={'primary'}
                          onClick={() => {
                            //form.resetFields()
                            resetDIR(idName)
                            setViewMode(true)
                          }}
                          style={{ marginLeft: '0px' }}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    )}

                    <Form.Item >

                    </Form.Item>
                  </Col>
                  <Col span="3">

                  </Col>
                </Row>

              </Form>
            </div>

          </div>

        </div>
      </Container>
    </>
  );
}
